import {
  QuestionnaireItem,
  QuestionnaireResponseItem,
} from '@medplum/fhirtypes';

// -----------------------------------------------------------------------------
export const mapQuestionnaireResponseItemToQuestionnaireItem = (
  questionnaireItem: QuestionnaireItem[] | undefined,
  responseItem: QuestionnaireResponseItem[] | undefined
): QuestionnaireItem[] | undefined => {
  return questionnaireItem?.map((item) => {
    const existingResponseItem =
      responseItem?.find((i) => i.linkId === item.linkId) || undefined;

    if (item.type === 'group' && existingResponseItem) {
      return {
        ...item,
        item: mapQuestionnaireResponseItemToQuestionnaireItem(
          item.item,
          existingResponseItem.item
        ),
      };
    }

    // For repeatable groups, don't inherit existing response data as initial values
    if (item.repeats) {
      return {
        ...item,
        initial: item.initial,
      };
    }
    // For non-repeatable items, preserve existing response data
    return {
      ...item,
      initial: existingResponseItem?.answer || item.initial,
    };
  });
};
